import React, { useEffect } from 'react';
import '../../css/PortalModal.css';

export default function PortalModal({
  open,
  title = 'Notice',
  children,
  onClose,
  primaryLabel = 'OK',
  variant = 'info',
}) {
  useEffect(() => {
    if (!open) return undefined;
    function handleKeyDown(event) {
      if (event.key === 'Escape') onClose?.();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className='portal-modal-backdrop' role='presentation'>
      <section className={'portal-modal portal-modal-' + variant} role='dialog' aria-modal='true' aria-labelledby='portal-modal-title'>
        <header className='portal-modal-header'>
          <h2 id='portal-modal-title'>{title}</h2>
          <button type='button' className='portal-modal-close' onClick={onClose} aria-label='Close dialog'>x</button>
        </header>
        <div className='portal-modal-body'>{children}</div>
        <footer className='portal-modal-footer'>
          <button type='button' className='portal-modal-primary' onClick={onClose}>{primaryLabel}</button>
        </footer>
      </section>
    </div>
  );
}
